import { createApp, defineCustomElement } from 'vue';
import {
  applyPolyfills,
  defineCustomElements,
} from '@tradein/stencil-components/loader';
import { seamlessCustomElement } from '@seamless/vite-plugin-vue-wc-css/seamless-custom-element';

import Main from './Main.vue';
import { createWcWrapper } from './wcWrapper';
import i18nManager from './composables/i18nManager';
import setup from './composables/setup';

applyPolyfills().then(() => {
  defineCustomElements();
});

const app: any = createApp(process.env.NODE_ENV === 'production' ? {} : Main);
setup().setupErrorHandler(app);
i18nManager().createI18nService(app);

if (process.env.NODE_ENV === 'production') {
  const WrappedCustomComponent: any = createWcWrapper(Main as any, app);
  const CustomElement: any = defineCustomElement(WrappedCustomComponent);
  const WrappedCustomElement = seamlessCustomElement(CustomElement);
  window.customElements.define('tradein-app', WrappedCustomElement);
} else {
  app.mount('#app');
}
